<div class="date-selector-wrapper">
    <custom-dropdown [items]="months" [(selectedItem)]="selectedMonth" [getItemLabel]="getMonthLabel" [width]="'80px'" [backgroundTone]="'light'"/>
    <custom-dropdown [items]="years" [(selectedItem)]="selectedYear" [getItemLabel]="getYearLabel" [width]="'90px'" [backgroundTone]="'light'"/>
</div>